import { useState, useEffect } from 'react';

const PHONE_NUMBER = '(804) 362-2555';
const PHONE_HREF = 'tel:+18043622555';
const SMS_HREF = 'sms:+18043622555';
const PROPOSAL_HREF = 'https://api.leadconnectorhq.com/widget/form/0ZsIY0jYLaF8aXm2FeXI';

export default function MobileCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Mobile sticky bottom bar - minimal, clean design */}
      <div className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100 shadow-2xl transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}>
        <div className="px-4 py-3 flex items-center gap-2.5">
          {/* Primary CTA - takes 65% width */}
          <a
            href={PROPOSAL_HREF}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-[0_0_65%] flex items-center justify-center gap-2 py-3.5 bg-[#52AB98] text-white text-sm font-bold rounded-[14px] cursor-pointer whitespace-nowrap shadow-md hover:bg-[#478F82] transition-all"
          >
            <i className="ri-file-list-3-line text-base"></i>
            <span>Get My Proposal</span>
          </a>

          {/* Text Us - compact icon button */}
          <a
            href={SMS_HREF}
            className="flex-1 flex flex-col items-center justify-center gap-1 py-2 bg-[#D98CA3]/10 text-[#D98CA3] rounded-[14px] cursor-pointer whitespace-nowrap hover:bg-[#D98CA3]/15 transition-all"
            aria-label={`Text us at ${PHONE_NUMBER}`}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-chat-1-line text-lg"></i>
            </div>
            <span className="text-[10px] font-semibold">Text</span>
          </a>

          {/* Call Now - compact icon button */}
          <a
            href={PHONE_HREF}
            className="flex-1 flex flex-col items-center justify-center gap-1 py-2 bg-[#52AB98]/10 text-[#52AB98] rounded-[14px] cursor-pointer whitespace-nowrap hover:bg-[#52AB98]/15 transition-all"
            aria-label={`Call us at ${PHONE_NUMBER}`}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-lg"></i>
            </div>
            <span className="text-[10px] font-semibold">Call</span>
          </a>
        </div>

        {/* Safe area spacer for iOS */}
        <div className="h-safe-bottom bg-white" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} />
      </div>
    </>
  );
}